module.exports = __webpack_public_path__ + "img/right-more-1.55b3ee6c.png";